import FishMarketDetailScreen from '../../screens/MainPage/FishMarketDetailScreen'

export default FishMarketDetailScreen


// WEBPACK FOOTER //
// ./src/containers/MainPage/FishDetail.js